<router-outlet></router-outlet>

@if (isInitialLoad) {
<div class="route-loading">
  <lin-spinner [diameter]="48"></lin-spinner>
</div>
}
